import { render, staticRenderFns } from "./AffiliationErrorPage.vue?vue&type=template&id=2bccfa09&scoped=true&"
import script from "./AffiliationErrorPage.vue?vue&type=script&lang=js&"
export * from "./AffiliationErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationErrorPage.vue?vue&type=style&index=0&id=2bccfa09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bccfa09",
  null
  
)

export default component.exports